import { Button } from '@chakra-ui/react';
import { jsx as _jsx } from "react/jsx-runtime";

var EnterButton = function EnterButton(_ref) {
  var _ref$w = _ref.w,
      w = _ref$w === void 0 ? 'auto' : _ref$w,
      _ref$handleClick = _ref.handleClick,
      handleClick = _ref$handleClick === void 0 ? function () {} : _ref$handleClick,
      rightIcon = _ref.rightIcon,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'solid' : _ref$variant,
      _ref$minW = _ref.minW,
      minW = _ref$minW === void 0 ? '' : _ref$minW,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'md' : _ref$size,
      children = _ref.children;
  return /*#__PURE__*/_jsx(Button, {
    px: "11",
    minW: minW,
    iconSpacing: "0",
    variant: variant,
    rightIcon: rightIcon,
    colorScheme: "brandScheme",
    onClick: handleClick,
    w: w,
    size: size,
    fontWeight: 400,
    e2eid: "Button_EnterButton_Button",
    children: children
  });
};

export default EnterButton;